





















































































































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import {
  AuditActingUser,
  AuditRequest,
  AuditRequestStatusStatus
} from '~/models/audit/request'
import CTimeline from '~/components/shared/configurable/timeline/CTimeline.vue'
import CTimelineItem from '~/components/shared/configurable/timeline/CTimelineItem.vue'
import { format } from '~/utils/date'
import { useDeps } from '~/compositions/dependency-container'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { faHistory, faTimes } from '@fortawesome/free-solid-svg-icons'
import { ciCalendarFa } from '~/icons/source/regular/calendar-fa'
import CTimeInput from '~/components/shared/configurable/datetime/CTimeInput.vue'
import PendingAppointmentScheduleItemFooter from '~/components/shared/audits/request/timeline/PendingAppointmentScheduleItemFooter.vue'
import AuditCompletedScheduleItemFooter from '~/components/shared/audits/request/timeline/AuditCompletedScheduleItemFooter.vue'
import PendingAuditItemFooter from '~/components/shared/audits/request/timeline/PendingAuditItemFooter.vue'
import PendingPaymentItemFooter from '~/components/shared/audits/request/timeline/PendingPaymentItemFooter.vue'
import CancelledByUserItemFooter from '~/components/shared/audits/request/timeline/CancelledByUserItemFooter.vue'
import AuditPendingApprovalItemFooter from '~/components/shared/audits/request/timeline/AuditPendingApprovalItemFooter.vue'

export default defineComponent({
  components: {
    AuditPendingApprovalItemFooter,
    CancelledByUserItemFooter,
    PendingPaymentItemFooter,
    AuditCompletedScheduleItemFooter,
    PendingAuditItemFooter,
    PendingAppointmentScheduleItemFooter,
    CTimelineItem,
    CTimeline,
    CTimeInput
  },
  props: {
    auditRequest: {
      type: Object as PropType<AuditRequest>,
      required: true
    },
    inModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    const [auditRequestService] = useDeps(AuditRequestService)
    const { auditRequest } = toRefs(props)

    const auditRequestHistory = computed(() => {
      return auditRequest.value.statusHistory
    })

    function formatDate(dateStr: string) {
      return format(dateStr)
    }
    function showActions(index: number) {
      // only show actions for the first item
      return index === 0
    }

    function handleStatusChange(status: AuditRequestStatusStatus) {
      emit('change-status', status)
    }

    const userIsAuditProvider = computed<boolean>(() => {
      return (
        auditRequest.value.currentUserRole === AuditActingUser.AUDIT_PROVIDER
      )
    })
    const userIsPayer = computed<boolean>(() => {
      return auditRequest.value.currentUserRole === AuditActingUser.PAYER
    })
    const userIsSeller = computed<boolean>(() => {
      return auditRequest.value.currentUserRole === AuditActingUser.SELLER
    })

    return {
      faTimes,
      faHistory,
      ciCalendarFa,
      formatDate,
      AuditRequestStatusStatus,
      auditRequestService,
      showActions,
      handleStatusChange,
      auditRequestHistory,
      userIsAuditProvider,
      userIsPayer,
      userIsSeller
    }
  }
})
